import styled from 'styled-components';
import Modal from 'react-modal';
import Colors from 'library/constants/colors';
import { IconPencil } from 'library/styles/icon';
import {
  Image as ItemDuplicateImage,
  ImageWrapper as ItemDuplicateContainer,
  TextWrapper as ItemDuplicateTextContainer,
} from 'library/components/view-mode/list/item/styles';
import { ButtonStyles } from '../../styles/button';
import { ShadowHarsh, TransitionConfig } from '../../constants/styles-config';

Modal.setAppElement('#root');

export const Container = styled(Modal)`
  width: ${({ width }) => width};
  z-index: ${({ isPrior }) => (isPrior ? 41 : 40)};
  margin: 100px auto;
  background: ${Colors.shade08};
  box-shadow: 0 2px 24px rgba(45, 49, 50, 0.25);
  border-radius: 4px;
  //z-index: 40;
`;

export const ContentInfo = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 32px 40px;
  font-size: 16px;
  border-radius: 8px;
  border: none;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px 40px;
  width: ${({ isLongerModal }) => (isLongerModal ? '938px' : '638px')};
  position: relative;
  background: ${({ isLongerModal }) => (isLongerModal ? `${Colors.shade07}` : `${Colors.shade08}`)};
  max-height: 400px;
  overflow-y: scroll;
`;

export const Info = styled.div`
  margin-top: 20px;
  width: 100%;
  font-size: 16px;
  color: ${Colors.shade09};
`;

export const Text = styled.h4`
  font-size: 18px;
  line-height: 22px;
  color: ${Colors.shade01};
  margin: 0;
  margin-bottom: 10px;
`;

export const CancelButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 14px 19px;
  margin-right: 15px;
  min-width: ${(props) => props.cancelWidth};
  height: 48px;
  background: ${Colors.shade08};
  border: 2px solid ${Colors.violet};
  box-sizing: border-box;
  border-radius: 100px;
  cursor: pointer;
  font-weight: bold;
  font-size: 18px;
  line-height: 20px;
  text-align: center;
  color: ${Colors.violet};
  transition: background-color ${TransitionConfig}, box-shadow ${TransitionConfig};
  
  &:hover {
    background: ${Colors.shade07};
    box-shadow: ${ShadowHarsh};
  }
`;

export const ConfirmButton = styled.button`
  ${ButtonStyles};
  width: ${(props) => props.submitWidth};
  margin-top: 0;

  &:only-child {
    width: 100%;
  }
`;

export const Input = styled.input`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 584px;
  height: 56px;
  background:  ${Colors.shade08};
  box-shadow: 0 1px 0 ${Colors.shade06};
  border-radius: 8px;
  border: none;
  cursor: pointer;
  padding-left: 52px;
  ::placeholder {color: ${Colors.shade01}};
  &:hover {
    background: ${Colors.shade07};
    box-shadow: 0 2px 0 ${Colors.shade04};
  }
  &:focus {
    background: ${Colors.shade07};
    box-shadow: 0 2px 0 ${Colors.violet};
    outline: none;
  }
`;

export const Icon = styled(IconPencil)``;

export const PickColorText = styled.p`
  font-size: 16px;
  line-height: 24px;
  color: ${Colors.shade01};
  margin: 0;
`;

export const ColorsContainer = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 60px;
  align-items: center;
`;

export const IconU = styled.i`
  font-size: 140px;
`;

export const ItemContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  align-items: flex-start;
  padding-bottom: 25px;

  ${ItemDuplicateContainer} {
    max-height: 120px;

    ${ItemDuplicateTextContainer} {
      padding-top: 0;
    }
    
    ${ItemDuplicateImage} {
      height: 100px;
      width: 100%;
      max-width: 100px;
      background-color: #fff;
    }
  }
}
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Item = styled.div`
  margin: 2px 0;
  height: 60px;
  width: 100%;
  display: flex;
  flex-direction: row;
  background: ${Colors.shade07};
  align-items: center;
  border-radius: 4px;
  padding: 0 10px;
  justify-content: space-between;
  position: relative;
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin-right: 20px;
  border-radius: 4px;
`;

export const Image = styled.img`
  width: 100%;
`;

export const ItemText = styled.p`
  max-width: 200px;
  font-size: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  margin-left: 10px;
`;

export const DeleteItemIconContainer = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const DeleteItemIcon = styled.i`
  height: 32px;
  font-size: 32px;
  color: ${Colors.violet};
  margin-bottom: 10px;
`;

export const SearchContainer = styled.div`
  padding: 32px 40px;
  background: ${Colors.shade07};
  display: flex;
  flex-direction: row;
  position: relative;
`;

export const SearchInput = styled.input`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: ${({ isLongerModal }) => (isLongerModal ? '884px' : '584px')};
  height: 40px;
  background: ${Colors.shade08};
  border-radius: 48px;
  border: none;
  cursor: pointer;
  padding-left: 52px;
  outline: none;
`;

export const SearchIcon = styled.i`
  font-size: 32px;
  color: ${Colors.violet};
  position: absolute;
  top: ${({ top }) => (top || '12px')};
  margin-left: 10px;
`;

export const SelectProjectForm = styled.form`
  display: flex;
  flex-direction: column;
  padding: 0;
  width: 603px;
`;

export const SelectRadio = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  width: 603px;
`;

export const ProjectLabel = styled.label`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 18px 18px 18px 25px;
  height: 40px;
  background: ${(props) => (props.selected ? `${Colors.violet}` : `${Colors.shade07}`)};
  width: 98.6%;
  margin-bottom: 4px;
  border-radius: 4px;
  cursor: pointer;
`;

export const ProjectOption = styled.input`
  display: none;
`;

export const ProjectIcon = styled.i`
  font-size: 32px;
  background: ${(props) => (props.selected ? `${Colors.shade08}` : 'none')};
  width: 17px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: ${(props) => (props.selected ? `${Colors.violet}` : `${Colors.shade05}`)};
  //background: ${(props) => (props.selected ? `${Colors.shade08}` : 'none')};
`;

export const ProjectImg = styled.div`
  width: 40px;
  height: 40px;
  background: black;
  border-radius: 4px;
  margin-left: 17px;
`;
export const ProjectText = styled.p`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  color: ${(props) => (props.selected ? `${Colors.shade08}` : `${Colors.shade02}`)};

  margin-left: 20px;
`;

export const ProjectInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const IconPlus = styled.i`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: ${Colors.violet};
`;

export const CreateNewProjectButtonText = styled.span`
  font-weight: bold;
  font-size: 15px;
  line-height: 20px;
  color: ${Colors.shade01};
`;

export const CreateNewButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px 40px;
  width: 638px;
  position: relative;
  background: #FFFFFF;
`;

export const CreateNewButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 40px;
  background: ${Colors.shade07};
  width: 100%;
  height: 40px;
  border: none;
  cursor: pointer;
  font-weight: bold;
  font-size: 15px;
  line-height: 20px;
  color: ${Colors.shade01};
  &:hover {
    background: ${Colors.shade06};
  }
  &:focus {
    background: ${Colors.violet};
  }  
  &:focus > ${IconPlus} {
      color: ${Colors.shade08};
    }
  }
  &:focus > ${CreateNewProjectButtonText} {
    color: ${Colors.shade08};
  }
`;

export const BelowContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 2px solid ${Colors.shade05};
  padding: 32px 40px;
`;
export const BelowTitle = styled.h3`
  margin: 0 0 25px 0;
  font-weight: bold;
  font-size: 24px;
  line-height: 29px;
  color: ${Colors.shade01};
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 638px;
  position: relative;
`;

export const IconLayers = styled.i`
  font-size: 32px;
  color: ${Colors.violet};
  position: absolute;
  top: 12px;
  left: 7px;
`;

export const BelowText = styled.p`
  margin-top: 25px;
  font-size: 16px;
  line-height: 24px;
  color: ${Colors.shade02};
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TopText = styled.p`
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  color: ${Colors.shade02};
  margin: 0 0 4px 0;
`;

export const StyledForm = styled.form``;

export const BarcodeContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px 40px;
  background: ${Colors.shade07};
  border-radius: 24px;
  width: 558px;
`;

export const BarcodeTitle = styled.h3`
  font-weight: bold;
  font-size: 24px;
  line-height: 29px;
  color: ${Colors.shade02};
  margin-top: 0;
  margin-bottom: 24px;
`;

export const ColorState = styled.span`
  color: ${({ isActive }) => (isActive ? `${Colors.success}` : `${Colors.error}`)};
`;

export const BarcodeListTitle = styled.h4`
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  color: ${Colors.shade02};
  margin-bottom: 10px;
  margin-top: 0;
`;

export const BarcodeList = styled.ol`
  margin: 0;
  padding-left: 20px;
`;

export const InstructionElement = styled.li`
  font-size: 18px;
  line-height: 28px;
`;

export const RadioButton = styled.div`
  width: 622px;
  position: relative;
  //margin: 3px 4px;
  padding: 3px 8px;
  height: 34px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  //border-bottom: ${(isLastElement) => (!isLastElement ? 'none' : `1px solid ${Colors.shade06};`)}; 
  font-size: 18px;
  line-height: 28px;
  color: ${Colors.shade01};

  i {
    color: ${({ isNew }) => (isNew ? Colors.green : 'inherit')};
    font-size: 28px;
  }

  &:hover {
    cursor: pointer;
    background-color: ${Colors.shade07};
  }
`;

export const CheckboxButton = styled.div`
  width: 622px;
  position: relative;
  //margin: 3px 4px;
  padding: 3px 8px;
  height: 34px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  //border-bottom: ${(isLastElement) => (!isLastElement ? 'none' : `1px solid ${Colors.shade06};`)}; 
  font-size: 18px;
  line-height: 28px;
  color: ${Colors.shade01};
  &:hover {
    cursor: pointer;
    background: ${Colors.shade07};
  }
`;

export const RadioLabel = styled.label`
  position: absolute;
  top: 25%;
  left: 10px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: white;
  border: 2px solid ${Colors.violet};
`;

export const CheckboxLabel = styled.label`
  position: absolute;
  top: 25%;
  left: 10px;
  width: 16px;
  height: 16px;
  border-radius: 1px;
  background: white;
  border: 2px solid ${Colors.violet};
`;

export const Radio = styled.input`
  margin: 0 10px;
  opacity: 0;
  z-index: 1;
  border: 2px solid ${Colors.violet};
  background: ${Colors.violet};
  cursor: pointer;
  
  &:hover ~ ${RadioLabel} {
    //background: ${Colors.violet};
    &::after {
      content: "";
      display: block;
      border-radius: 50%;
      width: 12px;
      height: 12px;
      margin: 6px;
      background: ${RadioLabel}
    }
  }
  ${(props) => props.checked
          && ` 
    &:checked + ${RadioLabel} {
      background: ${Colors.shade08};
      &::after {
        content: "";
        display: block;
        border-radius: 50%;
        width: 12px;
        height: 12px;
        margin: 2px;
        background: ${Colors.violet};
      }
    }
  `}
`;

export const Checkbox = styled.input`
  margin: 0 10px;
  opacity: 0;
  z-index: 1;
  border: 2px solid ${Colors.violet};
  background: ${Colors.violet};
  cursor: pointer;
  &:hover ~ ${CheckboxLabel} {
    //background: ${Colors.violet};
    &::after {
      content: "";
      display: block;
      border-radius: 1px;
      width: 12px;
      height: 12px;
      margin: 6px;
      background: ${CheckboxLabel}
    }
  }
  ${(props) => props.checked
          && ` 
    &:checked + ${CheckboxLabel} {
      background: ${Colors.shade08};
      &::after {
        content: "";
        display: block;
        border-radius: 1px;
        width: 12px;
        height: 12px;
        margin: 2px;
        background: ${Colors.violet};
      }
    }
  `}
`;

export const FooterContainer = styled.div`
  display: ${({ footer }) => (footer ? 'flex' : 'none')};
  flex-direction: row;
  align-items: flex-start;
  padding: 32px 40px;
  width: 100%;
  box-sizing: border-box;
  background: ${({ contrasting }) => (contrasting ? Colors.shade06 : Colors.shade07)};
  justify-content: space-between;
  ${({ isThirdActionEnabled }) => (isThirdActionEnabled ? `
     ${ConfirmButton} {
      width: auto;
      min-width: 120px;
      margin: 0 5px;
  
      &:last-child {
        width: 100%;
      }
    }
  ` : '')};
`;

export const Line = styled.div`
  width: 100%;
  background: ${Colors.shade06};
  height: 1px;
  margin: 4px 0;
  display: ${({ none }) => (none || 'block')};
`;
